<template>
  <div>
    <v-row no-gutters>
      <span class="body-2 font-weight-medium">Your Local Council Details</span>
    </v-row>
    <v-row no-gutters>
      <span class="body-2">Please enter your Council details so we can communicate with you for account administration and billing purposes.</span>
    </v-row>

    <div>
      <v-row>
        <v-col>
          <span class="caption">My Email Address</span>
          <v-text-field outlined dense
                        v-model="fields.email"
                        :error-messages="isEmailValid"
          ></v-text-field>
        </v-col>
        <v-col>
          <span class="caption">My Phone Number</span>
          <v-text-field outlined dense
                        v-model="fields.phone"
                        :error-messages="isPhoneValid"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mt-n6">
        <v-col>
          <span class="caption">Address Line 1</span>
          <v-text-field outlined dense
                        v-model="fields.address"
                        :error-messages="isAddressValid"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-row no-gutters>
            <v-col>
              <span class="caption">Address Line 2</span>
            </v-col>
            <v-col align="right">
              <span class="caption grey--text">(optional)</span>
            </v-col>
          </v-row>
          <v-text-field outlined dense
                        v-model="fields.address2"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mt-n6">
        <v-col>
          <span class="caption">Village, Town or City</span>
          <v-text-field outlined dense
                        v-model="fields.town"
                        :error-messages="isTownValid"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-row no-gutters>
            <v-col>
              <span class="caption">District or County</span>
            </v-col>
            <v-col align="right">
              <span class="caption grey--text">(optional)</span>
            </v-col>
          </v-row>
          <v-text-field outlined dense
                        v-model="fields.district"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-n3" style="width: 25%">
        <v-col>
          <span class="caption">Postcode</span>
          <v-text-field outlined dense
                        v-model="fields.postcode"
                        :error-messages="isPostcodeValid"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <v-row no-gutters class="mt-2">
      <span v-if="isAllValid" class="body-2">Click "Next" to continue the signup process.</span>
      <span v-else class="body-2 font-weight-medium" style="color: #BF1722">Please complete all required fields.</span>
    </v-row>

  </div>
</template>

<script>
  export default {
    name: "StepFive",
    components: {},
    props: {
      valid: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        fields: {
          email: '',
          phone: '',
          address: '',
          address2: '',
          town: '',
          district: '',
          postcode: '',
        },
        fieldsError: {
          email: false,
          phone: false,
          address: false,
          town: false,
          postcode: false,
        },
      }
    },
    computed: {
      isEmailValid() {
        let email = this.fields.email;
        let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let messages = [];
        if (email === '') {
          this.fieldsError.email = true;
        } else if (!regex.test(email)) {
          this.fieldsError.email = true;
          messages.push('Invalid email.');
        } else {
          this.fieldsError.email = false;
          messages = [];
        }
        return messages;
      },
      isPhoneValid() {
        let phone = this.fields.phone;
        let regex = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/;
        let messages = [];
        if (phone === '') {
          this.fieldsError.phone = true;
        } else if (!regex.test(phone)) {
          this.fieldsError.phone = true;
          messages.push('Invalid phone number.');
        } else {
          this.fieldsError.phone = false;
          messages = [];
        }
        return messages;
      },
      isAddressValid() {
        let address = this.fields.address;
        let messages = [];
        if (address === '') {
          this.fieldsError.address = true;
        } else {
          this.fieldsError.address = false;
          messages = [];
        }
        return messages;
      },
      isTownValid() {
        let town = this.fields.town;
        let messages = [];
        if (town === '') {
          this.fieldsError.town = true;
        } else {
          this.fieldsError.town = false;
          messages = [];
        }
        return messages;
      },
      isPostcodeValid() {
        let postcode = this.fields.postcode;
        let regex = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/;
        let messages = [];
        if (postcode === '') {
          this.fieldsError.postcode = true;
        } else if (!regex.test(postcode)) {
          this.fieldsError.postcode = true;
          messages.push('Invalid postcode.');
        } else {
          this.fieldsError.postcode = false;
          messages = [];
        }
        return messages;
      },
      isAllValid() {
        let valid = !this.fieldsError.email && !this.fieldsError.phone && !this.fieldsError.address && !this.fieldsError.town && !this.fieldsError.postcode;
        this.$emit('update:valid', valid);
        if (valid) {
          this.$store.commit('SET_COUNCIL_DETAILS', this.fields);
        }
        return valid;
      },
    },
    methods: {}
  }
</script>
